import React from 'react';
import {useSearchParams} from "react-router-dom";

const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const isSameParams = (params: Record<string, any>) => {
        const current = new URLSearchParams(searchParams).toString();
        const next = new URLSearchParams(params as Record<string, string>).toString();
        return current === next;
    };

    const _getAllQueryParams = () => {
        const allQueryParams: any = {};
        // @ts-ignore
        for (const entry of searchParams.entries()) {
            allQueryParams[entry[0]] = entry[1];
        }

        return allQueryParams;
    };

    const addQueryParam = (param: {}, options?: { replace?: boolean }) => {
        // get existed query params
        const allParams = _getAllQueryParams();
        const nextParams = {...allParams, ...param};

        // set existed params and add another one
        if (!isSameParams(nextParams)) {
            setSearchParams(nextParams, { replace: !!options?.replace });
        }
    };

    const removeQueryParam = (paramName: string, options?: { replace?: boolean }) => {
        // get existed query params
        const allParams = _getAllQueryParams();
        if (!(paramName in allParams)) return;
        delete allParams[paramName];

        // set remaining params
        if (!isSameParams(allParams)) {
            setSearchParams({...allParams}, { replace: !!options?.replace });
        }
    }

    return {
        addQueryParam,
        removeQueryParam,
        searchParams,
        setSearchParams,
    }
}

export default useQueryParams;